import { render, staticRenderFns } from "./rich-editor-widget.vue?vue&type=template&id=833c2e64&scoped=true"
import script from "./rich-editor-widget.vue?vue&type=script&lang=js"
export * from "./rich-editor-widget.vue?vue&type=script&lang=js"
import style0 from "./rich-editor-widget.vue?vue&type=style&index=0&id=833c2e64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833c2e64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('833c2e64')) {
      api.createRecord('833c2e64', component.options)
    } else {
      api.reload('833c2e64', component.options)
    }
    module.hot.accept("./rich-editor-widget.vue?vue&type=template&id=833c2e64&scoped=true", function () {
      api.rerender('833c2e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/rich-editor-widget.vue"
export default component.exports